import { useEffect } from "react";
import { BRAND } from "../data/content";

// Minimal, dependency-free head manager for titles, descriptions, OG tags,
// canonicals and JSON-LD. Keeps us light while still giving search engines
// clean per-route metadata to work with.

const upsertMeta = (attr, value, content) => {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${value}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, value);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

const upsertLink = (rel, href) => {
  if (!href) return;
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
};

const setJsonLd = (id, data) => {
  let el = document.getElementById(id);
  if (!data) {
    if (el) el.remove();
    return;
  }
  if (!el) {
    el = document.createElement("script");
    el.type = "application/ld+json";
    el.id = id;
    document.head.appendChild(el);
  }
  el.textContent = JSON.stringify(data);
};

export default function Seo({ title, description, path, image, type = "website", jsonLd }) {
  useEffect(() => {
    const fullTitle = title ? `${title} | ${BRAND.short}` : `${BRAND.name} | ${BRAND.tagline}`;
    const canonical = `${BRAND.url}${path || "/"}`;
    const ogImage =
      image ||
      "https://images.unsplash.com/photo-1540555700478-4be289fbecef?auto=format&fit=crop&w=1200&q=80";
    document.title = fullTitle;
    upsertMeta("name", "description", description);
    upsertLink("canonical", canonical);
    upsertMeta("property", "og:title", fullTitle);
    upsertMeta("property", "og:description", description);
    upsertMeta("property", "og:type", type);
    upsertMeta("property", "og:url", canonical);
    upsertMeta("property", "og:image", ogImage);
    upsertMeta("property", "og:site_name", BRAND.name);
    upsertMeta("name", "twitter:card", "summary_large_image");
    upsertMeta("name", "twitter:title", fullTitle);
    upsertMeta("name", "twitter:description", description);
    upsertMeta("name", "twitter:image", ogImage);
    setJsonLd("page-schema", jsonLd);
    return () => setJsonLd("page-schema", null);
  }, [title, description, path, image, type, jsonLd]);
  return null;
}
